import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y" }
const _hoisted_2 = {
  key: 0,
  class: "u-form-heading unset-text-align"
}
const _hoisted_3 = { class: "gev19-optional-module" }
const _hoisted_4 = { class: "o-grid o-grid--no-y-gutter o-grid--align-flex-end" }
const _hoisted_5 = { class: "o-grid__cell o-grid__cell--12" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["o-grid", {
      'u-mar-t-1': _ctx.produktmodulAuschluss.modulPrefix === '',
      'u-mar-t-2': _ctx.produktmodulAuschluss.modulPrefix !== '',
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.produktmodulAuschluss.modulPrefix !== '')
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.produktmodulAuschluss.modulPrefix), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200", {
        'u-form-grid-nospace-y': _ctx.produktmodulAuschluss.modulPrefix === '',
        'u-form-grid-lowspace-y': _ctx.produktmodulAuschluss.modulPrefix !== '',
      }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.piniaStore.state.isMakler)
              ? (_openBlock(), _createElementBlock("h3", {
                  key: 0,
                  class: "u-mar-y-0",
                  innerHTML: _ctx.produktmodulAuschluss.name
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.piniaStore.state.isMakler)
              ? (_openBlock(), _createElementBlock("h3", {
                  key: 1,
                  class: "u-mar-y-0",
                  innerHTML: _ctx.produktmodulAuschluss.nameMakler
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            (!_ctx.piniaStore.state.isMakler || _ctx.produktmodulAuschluss.bodyMakler === undefined)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  innerHTML: _ctx.produktmodulAuschluss.body,
                  class: "u-mar-b-0"
                }, null, 8, _hoisted_8))
              : (_openBlock(), _createElementBlock("p", {
                  key: 3,
                  innerHTML: _ctx.produktmodulAuschluss.bodyMakler,
                  class: "u-mar-b-0"
                }, null, 8, _hoisted_9))
          ])
        ])
      ])
    ], 2)
  ], 2))
}